<div class="modal-header">
  <h2 class="news-title">{{ news.title }}</h2>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <div class="row">
    <!-- Left Column: News Content -->
    <div class="col-md-6">
      <p class="news-summary text-muted">{{ news.summary }}</p>
      <p class="news-body">{{ news.body }}</p>
      <p class="news-author">Avtor: <strong>{{ news.author }}</strong></p>
      <p class="news-date text-secondary">
        Objavljeno: {{ news.publishedAt | date: 'MMMM d, yyyy' }}
      </p>
      <p *ngIf="news.facebookLink" class="news-facebook-link small">
        <a [href]="news.facebookLink" target="_blank">
          <fa-icon [icon]="faFacebook" class="me-1"></fa-icon>Oglej si objavo na Facebooku
        </a>
      </p>
    </div>

    <!-- Right Column: Image -->
    <div class="col-md-6 text-center" style="border-left: 1px solid #d0d0d0;">
      <img [src]="news.imageRef" alt="News Image" class="news-image img-fluid rounded">
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="closeModal()">Close</button>
</div>
